import * as service from '@/services/v1/notifications/inbox';

function maxId(items) {
  return items.reduce((acc, n) => (n.id > acc ? n.id : acc), 0);
}

export default {
  state: () => ({
    items: [],
    unreadCount: 0,
    loading: false,
    lastId: 0,
  }),
  getters: {
    items: (state) => state.items,
    unreadCount: (state) => state.unreadCount,
    loading: (state) => state.loading,
    lastId: (state) => state.lastId,
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
      state.lastId = maxId(items);
    },
    prependItems(state, items) {
      if (!items.length) return;
      state.items = [...items, ...state.items];
      const top = maxId(items);
      if (top > state.lastId) state.lastId = top;
    },
    setUnreadCount(state, count) {
      state.unreadCount = count;
    },
    setLoading(state, value) {
      state.loading = value;
    },
  },
  actions: {
    // Carga completa (ao abrir o sininho).
    async fetch({ commit }) {
      commit('setLoading', true);
      try {
        const { data } = await service.list();
        commit('setItems', data?.data?.items || []);
        commit('setUnreadCount', data?.data?.unread_count || 0);
      } finally {
        commit('setLoading', false);
      }
    },
    // Verificação incremental (cada 5 min): só o que chegou DEPOIS da última.
    async poll({ commit, state }) {
      const { data } = await service.list({ since: state.lastId || undefined });
      const novas = data?.data?.items || [];
      if (novas.length) commit('prependItems', novas);
      commit('setUnreadCount', data?.data?.unread_count ?? state.unreadCount);
      return novas;
    },
    async fetchCount({ commit }) {
      const { data } = await service.unreadCount();
      commit('setUnreadCount', data?.data?.unread_count || 0);
    },
    async markRead({ dispatch }, id) {
      await service.markAsRead(id);
      await dispatch('fetch');
    },
    async markUnread({ dispatch }, id) {
      await service.markAsUnread(id);
      await dispatch('fetch');
    },
    async markAll({ dispatch }) {
      await service.markAllAsRead();
      await dispatch('fetch');
    },
    async markAllUnread({ dispatch }) {
      await service.markAllAsUnread();
      await dispatch('fetch');
    },
    async deleteOne({ dispatch }, id) {
      await service.remove(id);
      await dispatch('fetch');
    },
    async deleteAll({ dispatch }) {
      await service.removeAll();
      await dispatch('fetch');
    },
  },
};
